import css from './graph.module.scss';

const ASPECT_RATIO = Number(orDie(css.ASPECT_RATIO));

export default {
  // svg[viewbox]
  SVG: {
    WIDTH: 1000,
    DEFAULT_ASPECT_RATIO: ASPECT_RATIO,
    HEIGHT: 1000 * ASPECT_RATIO,
  },
  // inner graph with grid/points/curve, but without labels
  GRAPH: {
    INNER_PADDING: 0.05, // distance from lead points to borders
    // padding for legend texts
    PADDING: {
      TOP: 10,
      LEFT: 40,
      RIGHT: 10,
      BOTTOM: 40,
    },
  },
  LEGEND: {
    // padding from OX & OY
    PADDING: {
      VERTICAL: 10,
      HORISONTAL: 10,
    },
    LABELS: {
      // max legend lines & texts
      COUNT: {
        HORISONTAL: 5,
        VERTICAL: 3,
      },
    },
  },
};
